// TODO: set this to a proper prod environment
module.exports = {
  apiKey: 'AIzaSyBltXk0OiulZ68yk47GtC3WChP3WaPsACg',
  authDomain: 'utekirke.firebaseapp.com',
  projectId: 'utekirke',
  storageBucket: 'utekirke.appspot.com',
  databaseURL: 'https://utekirke.firebaseio.com',
  messagingSenderId: '575038945003',
  appId: '1:575038945003:web:063066df14cd75e073b0ae',
  measurementId: 'G-JZFYKL4WDL',
};
